import { PatientDisplayCode } from "@libs/gateways/user-experience/UserExperienceGateway.dtos.ts";
import { LocalisationSettings } from "@shared-types/user-experience/localisation-settings.type.ts";

export const settings: Record<PatientDisplayCode, LocalisationSettings> = {
  CLI: { patientDisplay: "client" },
  PAT: { patientDisplay: "patient" }
};
